import { AppBar, Toolbar, Typography, Button, Box, IconButton, Menu, MenuItem } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { clientDoLogout } from "../../../store/thunks/clientAuthThunks";
import { useState } from "react";

export const FacturacionTopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { client } = useAppSelector((state) => state.clientAuth);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleLogout = () => {
    dispatch(clientDoLogout());
    navigate("/facturacion/login");
    setAnchorEl(null);
  };

  const isActive = (path: string) => location.pathname.includes(path);

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#0e368d" }}>
      <Toolbar>
        <Typography
          variant="h6"
          sx={{ cursor: "pointer", fontWeight: "bold" }}
          onClick={() => navigate("/facturacion")}
        >
          HVP - Portal de Facturación
        </Typography>

        <Box sx={{ flexGrow: 1, display: "flex", ml: 4, gap: 1 }}>
          <Button
            color="inherit"
            onClick={() => navigate("/")}
          >
            Inicio
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate("/facturacion")}
            sx={{ fontWeight: isActive("/facturacion") && !isActive("/nueva") && !isActive("/perfil") && !isActive("/facturas") ? "bold" : "normal" }}
          >
            Mis Facturas
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate("/facturacion/nueva")}
            sx={{ fontWeight: isActive("/nueva") ? "bold" : "normal" }}
          >
            Solicitar Factura
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate("/facturacion/guia")}
            sx={{ fontWeight: isActive("/guia") ? "bold" : "normal" }}
          >
            Guía
          </Button>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            color="inherit"
            onClick={() => navigate("/facturacion/perfil")}
          >
            Datos fiscales
          </Button>
          <Typography variant="body2">{client?.name}</Typography>
          <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)}>
            <AccountCircle />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
